module.exports = __webpack_public_path__ + "img/scalpel-line-dashed.54ea4696.svg";